<template>
  <el-container>
    <el-main>
      <div class="wrap">
        <div v-if="info" class="info-box">欢迎您！{{info.name}}</div>
        <div class="empty" v-if="!loading && (!list || list.length === 0)">还没有为您开放应用权限，请联系管理员</div>
        <div class="list clear" v-else>
          <el-row :gutter="20">
            <el-col :span="6" v-for="(item, index) in list" :key="index">
              <div class="application-item"><a class="entrance" :href="basePath + item.entrance">{{item.name}}</a></div>
            </el-col>
          </el-row>
        </div>
      </div>
    </el-main>
  </el-container>
</template>

<script>
import Service from '@/request/base'
import AccountService from '@/request/account'
export default {
  name: 'App',
  created () {
    this.loadPersonInfo()
    this.listPersonApplications()
    this.basePath = Service.basePath()
  },
  data() {
    return {
      loading: false,
      basePath: '',
      info: {},
      list: []
    }
  },
  watch: {
  },
  methods: {
    loadPersonInfo() {
      AccountService.current().then(res => {
        this.info = res && res.result ? res.result : {}
      })
    },
    listPersonApplications() {
      this.loading = true
      AccountService.userApplicationList().then(res => {
        this.list = res && res.result ? res.result : []
      }).finally(() => {
        this.loading = false
      })
    }
  }
};
</script>

<style scoped>
.wrap {
  width: 100%;
  height: 100%;
}
.info-box {
  text-align: center;
  padding: 50px;
  font-size: 24px;
  font-weight: bold;
  line-height: 48px;
}
.empty{
  text-align: center;
  padding: 50px;
  font-size: 24px;
  font-weight: bold;
  color: chocolate;
}
.list {
  padding: 50px;
}
.application-item {
  background: #d3dce6;
  border-radius: 4px;
  height: 36px;
  margin-bottom: 20px;
  text-align: center;
  line-height: 36px;
  font-size: 18px;
}
.application-item .entrance {
  color: #333;
  display: block;
}
</style>
